import createEnum from 'scripts/lib/create_enum';

const SelectAction = createEnum('ADD', 'REMOVE');
const TopicsMenuOptionType = createEnum('COLLAPSER', 'DIVIDER', 'EXPANDER', 'OPTION', 'GROUP_TITLE');
const COLLAPSE_SELECTED_OPTIONS_NUM = 5;

export { COLLAPSE_SELECTED_OPTIONS_NUM, SelectAction, TopicsMenuOptionType };
